export default function ProgramsServices() {
  const programs = [
    {
      icon: 'ri-tools-line',
      title: 'ورش تدريبية',
      frequency: 'ورشتان شهرياً',
      count: '24 ورشة سنوياً',
      description: 'ورش عملية متخصصة في ريادة الأعمال، التقنية، التصميم، وبناء المهارات المهنية',
      color: 'from-[#FF6B6B] to-[#FF8E53]',
      bg: 'bg-[#FF6B6B]/5',
      border: 'border-[#FF6B6B]/20',
      tags: ['ريادة أعمال', 'تقنية', 'تصميم', 'مهارات']
    },
    {
      icon: 'ri-user-star-line',
      title: 'لقاءات خبراء ومرشدين',
      frequency: 'شهرياً تقريباً',
      count: '8 لقاءات سنوياً',
      description: 'جلسات مع رواد أعمال ناجحين وخبراء قطاعيين لتوجيه الشباب وفتح آفاق جديدة',
      color: 'from-[#4ECDC4] to-[#44A08D]',
      bg: 'bg-[#4ECDC4]/5',
      border: 'border-[#4ECDC4]/20',
      tags: ['إرشاد', 'تواصل', 'خبرات']
    },
    {
      icon: 'ri-award-line',
      title: 'برامج تطوير مهني',
      frequency: 'دورتان سنوياً',
      count: 'برنامجان متخصصان',
      description: 'برامج مكثفة لتطوير الكفاءات المهنية وتأهيل الشباب لسوق العمل وبيئة الأعمال',
      color: 'from-[#667EEA] to-[#764BA2]',
      bg: 'bg-[#667EEA]/5',
      border: 'border-[#667EEA]/20',
      tags: ['تأهيل مهني', 'سوق العمل', 'كفاءات']
    },
    {
      icon: 'ri-trophy-line',
      title: 'مسابقات وهاكاثونات',
      frequency: 'ربع سنوياً',
      count: '4 فعاليات سنوياً',
      description: 'تحديات إبداعية وهاكاثونات تقنية لاكتشاف الأفكار المبتكرة ودعم أصحابها',
      color: 'from-[#F7971E] to-[#FFD200]',
      bg: 'bg-[#F7971E]/5',
      border: 'border-[#F7971E]/20',
      tags: ['ابتكار', 'تحديات', 'جوائز']
    },
    {
      icon: 'ri-community-line',
      title: 'فعاليات مجتمع',
      frequency: 'نصف سنوي',
      count: 'فعاليتان سنوياً',
      description: 'تجمعات مجتمعية تجمع الشباب والشركاء والداعمين في بيئة من التواصل والإلهام',
      color: 'from-emerald-500 to-green-600',
      bg: 'bg-emerald-50',
      border: 'border-emerald-200',
      tags: ['تواصل', 'مجتمع', 'شراكات']
    }
  ];

  const stats = [
    { number: '+40', label: 'فعالية سنوياً', icon: 'ri-calendar-event-line' },
    { number: '+500', label: 'مشارك في الفعاليات', icon: 'ri-group-line' },
    { number: '12', label: 'شهراً من البرامج المتواصلة', icon: 'ri-time-line' },
    { number: '100%', label: 'مجانية للأعضاء', icon: 'ri-gift-line' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white to-[#FFF5F3]">
      <div className="container mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#FF6B6B]/10 border border-[#FF6B6B]/20 text-[#FF6B6B] px-5 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-calendar-check-line"></i>
            ما يحدث داخل المساحة
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            البرامج والخدمات
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            المساحة ليست مجرد مكان — بل بيئة حية من البرامج والفعاليات المصممة
            لتسريع نمو الشباب وتحويل أفكارهم إلى واقع
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 text-center border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <i className={`${stat.icon} text-3xl text-[#FF6B6B] mb-3 block`}></i>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.number}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {programs.map((program, index) => (
            <div
              key={index}
              className={`group bg-white rounded-2xl p-8 border ${program.border} hover:shadow-2xl transition-all duration-300 hover:-translate-y-1`}
            >
              {/* Icon & Frequency */}
              <div className="flex items-start justify-between mb-6">
                <div className={`w-14 h-14 bg-gradient-to-br ${program.color} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${program.icon} text-white text-2xl`}></i>
                </div>
                <span className={`text-xs font-bold px-3 py-1.5 rounded-full ${program.bg} border ${program.border} text-gray-600`}>
                  {program.frequency}
                </span>
              </div>

              {/* Title & Count */}
              <h3 className="font-bold text-xl text-gray-900 mb-1">{program.title}</h3>
              <p className={`text-sm font-semibold mb-3 bg-gradient-to-r ${program.color} bg-clip-text text-transparent`}>
                {program.count}
              </p>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed mb-5">
                {program.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2">
                {program.tags.map((tag, i) => (
                  <span key={i} className="text-xs bg-gray-100 text-gray-600 px-3 py-1 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}

          {/* CTA Card */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 flex flex-col items-center justify-center text-center border border-gray-700 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <i className="ri-add-circle-line text-5xl text-[#FF8E53] mb-4"></i>
            <h3 className="font-bold text-xl text-white mb-3">برامج قادمة</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              البرامج تتوسع باستمرار بناءً على احتياجات المجتمع وشركاء الدعم
            </p>
            <span className="text-xs font-bold text-[#FF8E53] border border-[#FF8E53]/30 px-4 py-2 rounded-full">
              يُحدَّث دورياً
            </span>
          </div>
        </div>

        {/* Bottom Note */}
        <div className="bg-gradient-to-l from-[#FF6B6B]/10 to-[#FF8E53]/10 border border-[#FF6B6B]/20 rounded-2xl p-8 text-center">
          <i className="ri-information-line text-3xl text-[#FF6B6B] mb-3 block"></i>
          <p className="text-gray-700 font-medium text-lg">
            تُموَّل هذه البرامج من خلال شراكات الرعاية والتسويق —
            <span className="text-[#FF6B6B] font-bold"> وليس من ميزانية التأسيس</span>
          </p>
          <p className="text-gray-500 text-sm mt-2">
            مما يجعل نموذج التشغيل أكثر استدامةً وقابلية للتوسع
          </p>
        </div>

      </div>
    </section>
  );
}
